import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IClinicToClinicTransferOrdersFilterBody,
  IClinicToClinicTransferOrdersList,
  IClinicToClinicTransferOrdersListResponse,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useOrderTransferListAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<IClinicToClinicTransferOrdersListResponse[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IClinicToClinicTransferOrdersFilterBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${INVENTORY_MODULE?.ORDER_TRANSFER_LIST?.baseURL}`, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IClinicToClinicTransferOrdersList>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              return { status: true, message: "batch" };
            } else {
              setData([]);
              return { status: false, message: "order_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { data, execute };
};
